// Runtime config. Edit these after deploying the GAS backend (see app/gas/README.md).
// Until USE_GAS_AUTH is flipped to true, the legacy PIN gate continues to work.

export const USE_GAS_AUTH = false;

// Paste from "Deploy → Manage deployments" in the Apps Script editor.
// Must end with /exec (not /dev).
export const GAS_URL = '';

// From Google Cloud Console → APIs & Services → Credentials → OAuth 2.0 Client IDs.
export const OAUTH_CLIENT_ID = '';

// Optional: domain hint shown in the Google sign-in popup. Speeds up account
// picker for @helidirect.com users.
export const HOSTED_DOMAIN = 'helidirect.com';
